import { connect } from "react-redux";
import Layout from "./Layout";
import { closeModalRequest } from '../../store/actions/general.actions';

const mapDispatchToProps = { closeModalRequest };


export default connect(null, mapDispatchToProps)(Layout);